import { render, staticRenderFns } from "./changes.vue?vue&type=template&id=2693ee45&"
import script from "./changes.vue?vue&type=script&lang=js&"
export * from "./changes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports